import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ItSolutionWorkingPattern from "../Pages/ITSolutionsPages/ItSolutionWorkingPattern";
import ItSolution3DWorkStructure from "../Pages/ITSolutionsPages/ItSolution3DWorkStructure";
// import ItSolutionFive from "../Pages/ITSolutionsPages/ItSolutionprojectPortfolio";
import ItSolutionprojectPortfolio from "../Pages/ITSolutionsPages/ItSolutionprojectPortfolio"
import ItSolutionSix from "../Pages/ITSolutionsPages/ItSolutionWorkProcess";
import FooterSection from "../Layout/Footer";
import ItSolutionAbout from "../Pages/ITSolutionsPages/ItSolutionAbout"
import ItSolutionContact from "../Pages/ITSolutionsPages/ItSolutionContact"

gsap.registerPlugin(ScrollTrigger);

export default function MainITSolutionHero() {
    const wrapperRef = useRef(null);
    const titleRef = useRef(null);
    const subRef = useRef(null);
    const btnRef = useRef(null);
    const imageRef = useRef(null);
    const badgeRef = useRef(null);
    const textCircleRef = useRef(null);
    const cursorRef = useRef(null);
    const [isFixed, setIsFixed] = useState(false);

    const [menuActive, setMenuActive] = useState(false);

    // Continuous rotation of the circle text
    useEffect(() => {
        gsap.to(textCircleRef.current, {
            rotation: 360,
            duration: 15,
            repeat: -1,
            ease: "linear",
            transformOrigin: "center center",
        });
    }, []);

    // Sticky header
    useEffect(() => {
        ScrollTrigger.create({
            trigger: wrapperRef.current,
            start: "top top",
            end: "bottom top",
            onUpdate: (self) => setIsFixed(self.progress > 0.05),
        });
    }, []);

    // Cursor movement animation
    useEffect(() => {
        const cursor = cursorRef.current;
        const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        const mouse = { x: pos.x, y: pos.y };
        const speed = 0.2;

        const xSet = gsap.quickSetter(cursor, "x", "px");
        const ySet = gsap.quickSetter(cursor, "y", "px");

        window.addEventListener("mousemove", (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
        });

        gsap.ticker.add(() => {
            pos.x += (mouse.x - pos.x) * speed;
            pos.y += (mouse.y - pos.y) * speed;
            xSet(pos.x);
            ySet(pos.y);
        });

        // Hover scaling on interactive elements
        const links = document.querySelectorAll("a, button, .cursor-hover");
        links.forEach((el) => {
            el.addEventListener("mouseenter", () => {
                gsap.to(cursor, { scale: 2.5, backgroundColor: "#F26A33", duration: 0.3 });
            });
            el.addEventListener("mouseleave", () => {
                gsap.to(cursor, { scale: 1, backgroundColor: "#ffffff", duration: 0.3 });
            });
        });

        return () => {
            gsap.ticker.remove(() => { });
            window.removeEventListener("mousemove", () => { });
        };
    }, []);

    // Hero text + parallax animations
    useEffect(() => {
        const ctx = gsap.context(() => {
            const tl = gsap.timeline();
            // tl.from(titleRef.current.querySelectorAll(".line"), {
            //     y: 60,
            //     opacity: 0,
            //     stagger: 0.08,
            //     ease: "power4.out",
            //     duration: 0.9,
            // })
            tl.from(titleRef.current, {
                y: 80,
                opacity: 0,
                duration: 1
            })
                .from(subRef.current, { y: 20, opacity: 0, duration: 0.6 }, "-=0.4")
                .from(btnRef.current, { scale: 0.9, opacity: 0, duration: 0.5 }, "-=0.3")
                .from(badgeRef.current, { y: -30, opacity: 0, duration: 0.6 }, "-=0.6")
                .from(imageRef.current, { scale: 1.03, opacity: 0, duration: 1, ease: "power2.out" }, "-=0.7");

            gsap.to(imageRef.current, {
                yPercent: -8,
                ease: "none",
                scrollTrigger: {
                    trigger: wrapperRef.current,
                    start: "top top",
                    end: "bottom top",
                    scrub: 1,
                },
            });

            gsap.to(badgeRef.current, {
                rotation: 360,
                ease: "none",
                scrollTrigger: {
                    trigger: wrapperRef.current,
                    start: "top center",
                    end: "bottom top",
                    scrub: 3,
                },
            });


        }, wrapperRef);

        return () => ctx.revert();
    }, []);

    // Smooth scroll handler
    const handleScrollTo = (sectionId) => {
        const section = document.querySelector(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
        setMenuActive(false);
    };
    return (
        <>
            {/* Custom Mouse Cursor */}
            <div
                ref={cursorRef}
                className="fixed top-0 left-0 w-3 h-3 bg-white rounded-full pointer-events-none mix-blend-difference z-[9999] hidden md:block"
                style={{ transform: "translate(-50%, -50%)" }}
            ></div>

            <header
                className={`transition-all duration-700 z-50 ${isFixed
                    ? "fixed top-0 left-0 w-full bg-white/50 backdrop-blur-md shadow-md"
                    : "absolute top-0 left-0 w-full bg-transparent "
                    }`}
            >
                <div className="flex justify-between items-center py-4 px-6 lg:px-16 bg-transparent">
                    <a href="/https://viskohr.ae/" className="text-2xl font-bold">
                        <img
                            className={`transition-all duration-500 ${isFixed ? "w-44" : "w-48"}`}
                            src={require("../assets/viskohr-logo.webp")}
                            alt="Visko HR"
                        />
                    </a>

                    {/* <nav
                        className={`hidden md:flex gap-8 text-base text-white font-semibold ${menuActive ? "navbar-mobile" : ""
                            }`}
                    >
                        {["Home", "About", "Services", "work process", "Portfolio"].map(
                            (item) => (
                                <a
                                    key={item}
                                    href={`#${item.toLowerCase().replace(" ", "")}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        document
                                            .querySelector(`#${item.toLowerCase().replace(" ", "")}`)
                                            ?.scrollIntoView({ behavior: "smooth" });
                                        setMenuActive(false);
                                    }}
                                    className="hover:text-[#F26A33] cursor-pointer hover:scale-105 transition-transform hover:underline"
                                >
                                    {item}
                                </a>
                            )
                        )}
                    </nav> */}

                    {/* Navigation Menu */}
                    <nav className="hidden md:flex gap-8 text-base text-white font-semibold">
                        {[
                            { label: "Home", id: "#home" },
                            { label: "About", id: "#about" },
                            { label: "Services", id: "#services" },
                            { label: "Our Process", id: "#workstructure" },
                            { label: "Portfolio", id: "#portfolio" },
                            // { label: "Contact", id: "#contact" },
                        ].map((item) => (
                            <button
                                key={item.id}
                                onClick={() => handleScrollTo(item.id)}
                                className="hover:text-[#F26A33] cursor-pointer hover:scale-105 transition-transform hover:underline"
                            >
                                {item.label}
                            </button>
                        ))}
                    </nav>
                    <div className="flex flex-col md:flex-row gap-3 md:gap-8 md:justify-end">
                        <a href="https://viskohr.ae/" target="_blank"
                            className="relative flex-1 md:flex-none md:w-48 
                                inline-flex items-center justify-center 
                                px-6 py-2.5 
                                overflow-hidden  tracking-tighter text-white bg-gray-600 rounded-md group" rel="noreferrer"
                        >
                            <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-orange-600 rounded-full group-hover:w-56 group-hover:h-56"></span>
                            <span className="absolute bottom-0 left-0 h-full -ml-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-auto h-full opacity-100 object-stretch"
                                    viewBox="0 0 487 487"
                                >
                                    <path
                                        fillOpacity=".1"
                                        fillRule="nonzero"
                                        fill="#FFF"
                                        d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z"
                                    ></path>
                                </svg>
                            </span>
                            <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="object-cover w-full h-full"
                                    viewBox="0 0 487 487"
                                >
                                    <path
                                        fillOpacity=".1"
                                        fillRule="nonzero"
                                        fill="#FFF"
                                        d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z"
                                    ></path>
                                </svg>
                            </span>
                            <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
                            <span className="relative text-base font-semibold">
                                Visko Hr</span>
                        </a>
                        <button onClick={() => {
                            const contactSection = document.getElementById("contact");
                            if (contactSection) {
                                contactSection.scrollIntoView({ behavior: "smooth" });
                            }
                        }}
                            className="relative inline-flex cursor-pointer flex-1 md:flex-none md:w-48 
                            items-center justify-center 
                            px-6 py-2.5 
                            overflow-hidden tracking-tighter text-white bg-orange-600 rounded-md group" rel="noreferrer"
                        >
                            <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-gray-600 rounded-full group-hover:w-56 group-hover:h-56"></span>
                            <span className="absolute bottom-0 left-0 h-full -ml-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-auto h-full opacity-100 object-stretch"
                                    viewBox="0 0 487 487"
                                >
                                    <path
                                        fillOpacity=".1"
                                        fillRule="nonzero"
                                        fill="#FFF"
                                        d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z"
                                    ></path>
                                </svg>
                            </span>
                            <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="object-cover w-full h-full"
                                    viewBox="0 0 487 487"
                                >
                                    <path
                                        fillOpacity=".1"
                                        fillRule="nonzero"
                                        fill="#FFF"
                                        d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z"
                                    ></path>
                                </svg>
                            </span>
                            <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
                            <span className="relative text-base font-semibold">Contact Us</span>
                        </button>
                    </div>

                </div>
            </header>

            {/* HERO SECTION */}
            <section id="home" ref={wrapperRef} className="bg-[#0d0d0d] text-white overflow-hidden pt-24 relative">
                <div className="absolute top-40 right-80 w-[400px] h-[800px] bg-gradient-to-br from-orange-600 to-red-700 blur-[200px] opacity-60"></div>

                <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-6 pt-16 lg:pt-24 relative z-10">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
                        <div className="lg:col-span-7 text-center lg:text-left">
                            <h1
                                ref={titleRef}
                                className="text-3xl sm:text-5xl md:text-6xl lg:text-[60px] xl:text-[80px] font-semibold text-white leading-tight md:leading-[1.1]"
                            >
                                Trusted IT Experts in <br /> <span> Dubai Delivering Smart</span> <br />
                                <span className="text-[#F26A33]"> Digital Solutions.</span>
                            </h1>
                        </div>

                        <div className="lg:col-span-5 flex flex-col items-center lg:items-end gap-6 mt-0 lg:mt-0">
                            <div ref={subRef} className="max-w-sm text-gray-300 pt-6 text-center lg:text-right">
                                <p className="text-sm sm:text-base lg:text-lg">
                                    <span className="text-[#F26A33] mr-2">*</span>
                                    {/* Team of passionate tech experts delivering innovative IT solutions tailored to help
                                    businesses grow. */}
                                    Empowering Dubai businesses with innovative IT services, secure infrastructure, and scalable technology designed for growth, performance, and efficiency.
                                </p>
                            </div>
                            <div className="max-w-sm text-gray-300 mx-auto">
                                <div className="max-w-sm text-gray-300 mx-auto">
                                    <button onClick={() => {
                                        const contactSection = document.getElementById("contact");
                                        if (contactSection) {
                                            contactSection.scrollIntoView({ behavior: "smooth" });
                                        }
                                    }} ref={btnRef}
                                        className="relative inline-flex cursor-pointer items-center justify-center px-10 py-3.5 overflow-hidden tracking-tighter text-white bg-orange-600 rounded-full group" rel="noreferrer">
                                        <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-gray-600 rounded-full group-hover:w-56 group-hover:h-56"></span>
                                        <span className="absolute bottom-0 left-0 h-full -ml-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-auto h-full opacity-100 object-stretch" viewBox="0 0 487 487" >
                                                <path fillOpacity=".1" fillRule="nonzero" fill="#FFF" d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z"></path>
                                            </svg>
                                        </span>
                                        <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="object-cover w-full h-full" viewBox="0 0 487 487" >
                                                <path fillOpacity=".1" fillRule="nonzero" fill="#FFF" d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z"></path>
                                            </svg>
                                        </span>
                                        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
                                        <span className="relative text-base font-semibold flex items-center"> Get Free Consultation <Icon icon="tabler:arrow-up-right" className="text-lg ml-2" /></span>
                                    </button>
                                </div>
                            </div>

                            {/* Rotating Badge */}
                            <div className="relative lg:top-22 z-10 lg:right-52">
                                <div
                                    className="relative grid place-items-center rounded-full border-4 border-gray-800 shadow-2xl"
                                    style={{
                                        background:
                                            "radial-gradient(circle at 30% 30%, rgba(216,255,95,0.12), rgba(0,0,0,0.4))",
                                        width: "12rem",
                                        height: "12rem",
                                    }}
                                >
                                    <div
                                        className="bg-white/48 rounded-full p-4 shadow-lg grid place-items-center"
                                        style={{
                                            backgroundImage:
                                                "url('https://api.visko.group/public/assets/img/uploads/gallery/photo-1730817966782-d90134a1b4a2.webp')",
                                            width: "10rem",
                                            height: "10rem",
                                        }}
                                    >
                                        <svg ref={textCircleRef} viewBox="0 0 100 100" className="absolute w-40 h-40">
                                            <defs>
                                                <path
                                                    id="circlePath"
                                                    d="M 50, 50 m -35, 0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0"
                                                />
                                            </defs>
                                            <text fill="#fff" fontSize="8.5" letterSpacing="1.5">
                                                <textPath href="#circlePath">
                                                    ● DESIGN ● DEVELOPMENT ● DEPLOYMENT ●
                                                </textPath>
                                            </text>
                                        </svg>
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <img
                                                // src={require("../assets/viskologo.webp")}
                                                src="https://api.visko.group/public/assets/img/uploads/gallery/viskologo.webp"
                                                alt="Visko Logo"
                                                className="w-12"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Hero Image */}
                <div className="lg:mt-0 mt-2 relative max-w-screen-full mx-auto px-6 lg:px-28">
                    <div className="rounded-3xl overflow-hidden shadow-2xl w-full h-auto md:h-[420px] lg:h-[820px]">
                        <div
                            ref={imageRef}
                            className="w-full h-[240px] sm:h-[340px] md:h-[480px] lg:h-[720px] xl:h-[820px] bg-cover bg-center rounded-xl"
                            style={{
                                backgroundImage:
                                    // "url('https://api.visko.group/public/assets/img/uploads/gallery/photo-1714976326715-96d4a22f8da8.webp')",
                                    "url('https://api.visko.group/public/assets/img/uploads/ticket-docs/1767426949_2c6730e7968be542e82f.webp')",
                            }}
                        ></div>
                    </div>
                </div>
            </section>

            {/* <ItSolutionAbout />
            <ItSolutionServices />
            <ItSolutionWork />
            <ItSolutionFive />
            <ItSolutionSix />
            <ItSolutionContact /> */}

            <section id="about"><ItSolutionAbout /></section>
            <section id="services"><ItSolutionWorkingPattern /></section>
            <section id="workstructure"><ItSolution3DWorkStructure /></section>
            <section id="portfolio"><ItSolutionprojectPortfolio /></section>
            {/* <section><ItSolutionSix /></section> */}
            <section id="contact"><ItSolutionContact /></section>
            <FooterSection />
        </>
    );
}